(() => {
  const sectionSelector = '[data-section-type="ginyhome-social-videos"]';

  const syncAudioState = (card, video) => {
    const isMuted = video.muted;
    const mutedIcon = card.querySelector('[data-ginyhome-social-muted-icon]');
    const activeIcon = card.querySelector('[data-ginyhome-social-active-icon]');
    const muteButton = card.querySelector('[data-ginyhome-social-mute]');
    const muteLabel = card.querySelector('[data-ginyhome-social-mute-label]');
    const label = isMuted ? 'Attiva audio' : 'Disattiva audio';

    if (mutedIcon) mutedIcon.toggleAttribute('hidden', !isMuted);
    if (activeIcon) activeIcon.toggleAttribute('hidden', isMuted);
    if (muteButton) {
      muteButton.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
      muteButton.setAttribute('aria-label', label);
    }
    if (muteLabel) muteLabel.textContent = label;
  };

  const updateCardState = (card, video) => {
    const isPlaying = !video.paused && !video.ended;
    card.dataset.playing = isPlaying ? 'true' : 'false';
    const playControl = card.querySelector('[data-ginyhome-social-play]');
    const muteButton = card.querySelector('[data-ginyhome-social-mute]');
    if (playControl) playControl.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
    if (muteButton) {
      muteButton.setAttribute('aria-hidden', isPlaying ? 'false' : 'true');
      muteButton.tabIndex = isPlaying ? 0 : -1;
    }
    syncAudioState(card, video);
    card.setAttribute('aria-label', `${isPlaying ? 'Metti in pausa' : 'Riproduci'} video: ${card.dataset.caption}`);
  };

  const initSection = (section) => {
    if (!section || section.dataset.ginyhomeSocialReady === 'true') return;
    section.dataset.ginyhomeSocialReady = 'true';

    section.querySelectorAll('[data-ginyhome-social-card]').forEach((card) => {
      const video = card.querySelector('[data-ginyhome-social-video]');
      const muteButton = card.querySelector('[data-ginyhome-social-mute]');
      if (!video) return;

      if ('disableRemotePlayback' in video) video.disableRemotePlayback = true;

      const togglePlay = () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      card.addEventListener('click', (event) => {
        if (event.target.closest('[data-ginyhome-social-mute]')) return;
        togglePlay();
      });

      card.addEventListener('keydown', (event) => {
        if (event.target !== card || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        togglePlay();
      });

      video.addEventListener('play', () => {
        updateCardState(card, video);
      });
      video.addEventListener('pause', () => updateCardState(card, video));
      video.addEventListener('ended', () => updateCardState(card, video));
      video.addEventListener('volumechange', () => syncAudioState(card, video));
      video.addEventListener('loadedmetadata', () => syncAudioState(card, video));

      updateCardState(card, video);

      muteButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        video.muted = !video.muted;
      });
    });
  };

  const stopSection = (section) => {
    section?.querySelectorAll('video[data-ginyhome-social-video]').forEach((video) => video.pause());
  };

  const init = () => document.querySelectorAll(sectionSelector).forEach(initSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => initSection(event.target));
  document.addEventListener('shopify:section:unload', (event) => stopSection(event.target));
})();
